module.exports = __webpack_public_path__ + "static/media/005-computer.f992167d.svg";